<template>
  <div class="panel-content countDown-make-sentence-root">
    <!-- 顶部描述 -->
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>

    <!-------------------- 渲染普通的screen-text下图片内容 -------------------->
    <div class="panel-content-text" v-if="currItem.topic_type == 'tyhskk'">
      <!-- 题号 -->
      <div class="text-con">
        <div class="example">
          {{ currItem.is_example ? $t('hsk_example') : currItem.index }}
        </div>
        <div style=" flex: 1">
          <div v-for="(item, itemIndex) in currItem.screen_text" :key="currItem.index + itemIndex">
            <img v-if="item.type == 'image'" :src="baseUrl + item.content + '?width=1500'" alt="" />
            <PhoneticText v-else-if="item.type == 'pyhtml'" :showPinyin="true" :originData="item.content" :baseStyles="textBlackStyles"></PhoneticText>
            <p class="question-stem-text" v-else-if="item.type == 'text'">
              {{ item.content }}
            </p>
            <div class="question-stem-text" v-else-if="item.type == 'html'" v-html="item.content"></div>
<!--            <textarea style="width: 100%;height: 300px;line-height: 25px;font-size: 16px;" :placeholder="item.content" v-else-if="item.type == 'textarea'"></textarea>-->
            <el-input
              v-else-if="item.type == 'textarea'"
              type="textarea"
              :placeholder="item.content"
              height="260"
              v-model="inputTextData[item.index]"
              maxlength="300"
              show-word-limit
              rows="7"
            >
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <!-------------------- - 渲染录音功能模块 --------------------->
    <div class="panel-content-main" v-show="!ifGroup">
      <Recorder
        v-show="isExamMode && (!currItem?.answer || autoHandleAudio == currItem.index)"
        @recordEnd="recordEnd"
        :time="recordDuration"
        :isExamMode="isExamMode"
        :manualRecord="false"
        ref="commonRecorder"
      ></Recorder>
      <div
        v-if="
          ((!isExamMode && !ifGroup) || (!ifGroup && currItem?.answer)) &&
          autoHandleAudio != currItem.index
        "
      >
        <RecordPlayer
          v-if="currItem.answer"
          :key="currItem.index"
          :isExamMode="isExamMode"
          :soundUrl="currItem.answer"
          :simpleType="false"
          :fatherPause="fatherPause"
        ></RecordPlayer>
        <div v-else>{{ $t('hsk_homework_no_answer') }}</div>
      </div>
    </div>
    <!---------------------- 口语 结果渲染 ---------------------->
    <div
      class="panel-content-result"
      v-if="!isExamMode && !currItem.is_example && currItem.evaluate && !ifGroup"
    >
<!--      <p class="orange">{{ $t('hsk_reference_answer') }}</p>-->
      <p class="orange">{{ $t('hsk_reference_answer_hskk') }}</p>
      <p
        class="correct-answer"
        v-for="(txt, key) in currItem.evaluate.standard_answer"
        :key="key + currItem.index"
      >
        {{ txt }}
      </p>
    </div>
    <div class="correct-box" v-if="!isExamMode && analysisText && !currItem.is_example && !ifGroup">
      <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
      <p class="correct-box-answer">
        {{ analysisText }}
      </p>
    </div>
    <!-- 套题渲染 -->
    <section v-show="currItem.topic_type == 'ldld'">
      <!-- 套题的听力播放按钮 -- 非考试模式显示 -->
      <div class="panel-content-play-con" v-if="$route.query?.paperStatus != 1 && $route.query?.paperStatus != 2">
        <ButtonTool
          :type="isExamMode ? 'none' : 'play'"
          @click.native="clickPlayTopVoice(true)"
          v-show="topPlayStatus == 'play' && !isExamMode"
        ></ButtonTool>
        <ButtonTool
          v-show="topPlayStatus == 'pause' && !isExamMode"
          @click.native="clickPauseTopVoice()"
          type="pause"
          slot="content"
        ></ButtonTool>
      </div>
      <!-- 套题 -->
      <div class="panel-content-details">
        <div class="question-item" v-for="(item, itemIndex) in newQuestionList" :key="itemIndex">
          <!-- 渲染口语套题 -->
          <div class="question-item-stem">
            <div class="example" style="float:left;">{{ item?.is_example ? $('hsk_example') : item?.index }}</div>
            <div style="margin-top: 20px;" v-for="(it, itIndex) in item.screen_text" :key="item.index + itIndex">
              <img v-if="it.type == 'image'" :src="baseUrl + it.content + '?width=1500'" alt="" />
              <PhoneticText v-else-if="it.type == 'pyhtml'" :showPinyin="true" :originData="it.content" :baseStyles="textBlackStyles"></PhoneticText>
              <p class="question-stem-text" v-else-if="it.type == 'text'">
                {{ it.content }}
              </p>
              <div class="question-stem-text" v-else-if="it.type == 'html'" v-html="it.content"></div>
              <el-input
                v-else-if="it.type == 'textarea' && $route.query?.paperStatus != 1 && $route.query?.paperStatus != 2"
                type="textarea"
                :placeholder="it.content"
                height="260"
                maxlength="300"
                v-model="inputTextData[item.index]"
                show-word-limit
                rows="7"
              >
              </el-input>
            </div>
            <div class="stem-content">
              <img
                v-show="!isExamMode && (item?.playStatus == 'play' || !item?.playStatus)"
                @click="clickPlayVoice(item, true)"
                :src="iconPlay('play')"
                alt=""
              />
              <img
                v-if="!isExamMode && item?.playStatus == 'pause'"
                @click="clickPauseVoice(item)"
                :src="iconPlay('pause')"
                alt=""
              />
            </div>
          </div>
          <div class="panel-content-main">
            <Recorder
              v-show="isExamMode && (!item.answer || autoHandleAudio == item.index)"
              @recordEnd="recordEnd"
              :time="item.recordDuration"
              :isExamMode="isExamMode"
              :manualRecord="false"
              :ref="'commonRef' + item.index"
            ></Recorder>
            <div>
              <div v-if="(!isExamMode || item.answer) && autoHandleAudio != item.index">
                <RecordPlayer
                  :key="item.index"
                  v-if="item.answer"
                  :isExamMode="isExamMode"
                  :soundUrl="item.answer"
                  :simpleType="false"
                  :fatherPause="item.fatherPause"
                  :index="itemIndex"
                  @clickRecordPlayer="clickRecordPlayer"
                ></RecordPlayer>
                <div v-else>{{ $t('hsk_homework_no_answer') }}</div>
              </div>
            </div>
          </div>
          <div
            class="analyse-con"
            v-if="!isExamMode && !item.is_example && (item.evaluate || item.analysis[language])"
          >
            <div
              class="panel-content-result"
              v-if="!isExamMode && !item.is_example && item.evaluate"
            >
<!--              <p class="orange">{{ $t('hsk_reference_answer') }}</p>-->
              <p
                class="correct-answer"
                v-for="(txt, key) in item.evaluate.standard_answer"
                :key="key + item.index"
              >
<!--                {{ txt }}-->
              </p>
            </div>

            <div class="correct-box" v-if="!isExamMode && item.analysis[language]">
              <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
              <p class="correct-box-answer">
                {{ item.analysis[language] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import QuestionDescription from '@/components/hsk/questionDescription'
import Recorder from '@/components/ui/recorder/index'
import { getLanguageSelectList, getScreenTextByLanguage } from '@/utils/hskTool'
import RecordPlayer from './common/recordPlayer'
import { apiRequest } from '@/serves/http'
import PhoneticText from "@/components/ui/phoneticText";
export default {
  components: { QuestionDescription, Recorder, RecordPlayer, PhoneticText },

  data() {
    return {
      inputText: '',
      blankNum: 0,
      languageList: [],
      translationLanguage: '',
      translationStemList: [],
      showRecordBtn: true,
      showFormWave: false,
      recordDuration: 0,
      topPlayStatus: 'play',
      startTime: 0,
      middleTime: 0,
      newQuestionList: [],
      icons: {
        play: require('@/assets/images/btn_play_hsk.png'),
        pause: require('@/assets/images/btn_pause_hsk.png'),
        playHsk: require('@/assets/images/play_hsk.png'),
      },
      fatherPause: false,
      inputTextData: JSON.parse(sessionStorage.getItem('inputTextData')) || {},
    }
  },
  computed: {
    ifGroup() {
      if (this.currItem) {
        return this.currItem.ifGroup
      }
      return false
    },
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    analysisText() {
      return this.currItem.analysis
        ? this.currItem.analysis[this.language]
          ? this.currItem.analysis[this.language]
          : this.currItem.analysis['zh']
        : ''
    },

    isShowScores() {
      return !this.currItem.is_example && !this.isExamMode && !this.$route.query?.ifRecord
    },
    textBlackStyles() {
      return {
        // 拼音文本初始颜色
        originPinyinColor: "#3F4651",
        // 拼音文本字体大小
        pinyinFontSize: "10px",
        // 拼音文本 行高
        pinyinLineHeight: "14px",
        // 汉字文本初始颜色
        originHzColor: "#3E4651",
        // 拼音文本字体大小
        hzFontSize: "16px",
        // 汉字文本 行高
        hzLineHeight: "16px",
        // 行文 间距(下方间距)
        writingSpacing: "0px",
        // 分词间距
        wordSpacing: "10px",
      };
    },
  },
  watch: {
    inputTextData: {
      handler(newValue) {
        sessionStorage.setItem('inputTextData', JSON.stringify(newValue));
      },
      deep: true
    },
    currItem: {
      handler(val) {
        console.log(val, 'get change val')
        // 如果是套题
        if (val.ifGroup) {
          console.log(11111111)
          this.newQuestionList = val.questions.map((item, index) => {
            item.fatherPause = false
            item.analysisText = item.analysis[this.language]
              ? item.analysis[this.language]
              : item.analysis['cn']
            if (val.answer && val.answer.length > 0 && !this.changeBtn) {
              item.answer = val.answer[index]
              item.recordDuration = Number(item.seconds_limt)
            }
            return item
          })
        } else {
          this.recordDuration = Number(val.seconds_limt)
        }
        if (val.topic_type == 'ts') {
          // 如果是翻译，需要初始化多语言列表，展示对应的多语言题干
          this.languageList = getLanguageSelectList(this.currItem.screen_text_trans)
          this.translationLanguage =
            sessionStorage.getItem('translationLanguage') || this.languageList[0].value
          this.translationStemList = []
          this.currItem.questions.forEach((ques) => {
            let tempStem = getScreenTextByLanguage(ques.screen_text_trans, this.translationLanguage)

            this.translationStemList.push(tempStem)
          })
        }
      },
      immediate: true,
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    baseUrl: {
      type: String,
      default: '',
    },
    // 批改状态
    isMarked: {
      type: Number,
    },
    autoHandleAudio: {
      type: Number,
      default: -1,
    },
  },
  methods: {
    //根据状态显示播放/暂停按钮
    iconPlay(playType) {
      return this.icons[playType]
    },
    changeLanguage() {
      this.translationStemList = []
      this.currItem.questions.forEach((ques) => {
        let tempStem = getScreenTextByLanguage(ques.screen_text_trans, this.translationLanguage)
        this.translationStemList.push(tempStem)
      })
      sessionStorage.setItem('translationLanguage', this.translationLanguage)
    },
    // 开始录音
    handleStartRecord() {
      // 判断是否是套题
      // 如果是套题，则选中question下的组件进行操作；
      if (this.ifGroup) {
        console.log(this.currItem.index, 'this.currItem.index')
        let ref = eval('this.$refs.commonRef' + this.currItem.index)[0]
        ref && ref.start()
        this.$store.commit('SET_EXAMNATION_RECORD', true)

        // this.$refs[`commonRef${this.currItem.index}`].start()
      } else {
        // 如果不是套题，选中公共的方法下的start方法；
        this.$nextTick(() => {
          this.$refs.commonRecorder.start()
          this.$store.commit('SET_EXAMNATION_RECORD', true)
          console.log('开始倒计时')
        })
      }
    },
    // 上傳錄音方法
    uploadAudio(file) {
      console.log(file)
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        let url = `${window.ApiPath.hsk_upload_audio}?paper_id=${this.$route.query.paperId}&examination_type=${this.$route.query.examinationType}`
        url = this.$route.query.examination_id
          ? url + `&examination_id=${this.$route.query.examination_id}`
          : url
        formData.append('file', file)
        apiRequest
          .post(
            url,
            formData,
            { loading: true },
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          .then((res) => {
            console.log(res)
            if (res.errcode == 0) {
              resolve(res.data)
            } else {
              reject(res.errmsg)
            }
          })
          .catch((err) => {
            const _this = this
            layer.open({
              title: '',
              closeBtn: 0,
              content: _this.$t('failed_upload_record'),
              btn: [_this.$t('button_common_start_over')],
              yes: (index) => {
                _this.uploadAudio(file)
                layer.close(index)
              },
            })
            reject(err)
          })
      })
    },

    // 停止录音-上传音频-提交大难
    recordEnd(map3Blob) {
      let tempurl = URL.createObjectURL(map3Blob)
      let fileName = this.currItem.index + '.mp3'

      let file = new File([map3Blob], fileName, {
        type: 'audio/mp3',
        lastModified: Date.now(),
      })
      console.log(file)
      this.uploadAudio(file)
        .then((data) => {
          let answerUrl = data.url

          console.log(data)
          console.log('子组件结束')
          this.$store.commit('SET_EXAMNATION_RECORD', false)
          // 提交答案；
          let ansObj = {
            questionId: this.currItem.index,
            answer: answerUrl,
            judge: 0,
            scores: null,
            segmentCode: this.currItem.segment_code,
            partCode: this.currItem.part_code,
            ifGroup: this.currItem.ifGroup,
            topic_type: this.currItem.topic_type,
          }
          console.log(ansObj)
          setTimeout(() => {
            this.$emit('saveRes', ansObj)
            this.$emit('handleRecordEnd')
          })
        })
        .catch((error) => {
          console.log('上传失败了')
          // 彈窗重試
          // this.$message.error(this.$t('change_avatar_fail'))
        })

      // 通知主流程录音结束；
    },
    // 点击录音的播放按钮
    clickRecordPlayer(index) {
      if (this.isExamMode) {
        return
      }
      this.topPlayStatus = 'play'
      this.newQuestionList.forEach((val, key) => {
        val.playStatus = 'play'
        if (index != key) {
          val.fatherPause = !val.fatherPause
        }
      })
    },
    //点击播放小题题干
    clickPlayVoice(question) {
      console.log('播放小题题干')
      localStorage.removeItem('bigIndex')
      if (this.isExamMode) return
      this.resetPlayStatus(question, 'pause')
      this.topPlayStatus = 'play'
      let audioPath = this.baseUrl + question.listen.audio_file
      this.$player.play(audioPath)
      this.$player.onended = () => {
        this.resetPlayStatus(question, 'play')
      }
    },
    //点击暂停
    clickPauseVoice(question) {
      this.$player.pause()
      this.resetPlayStatus(question, 'play')
    },
    //点击播放顶部录音
    clickPlayTopVoice(status, isTryAgain) {
      console.log('clickPlayTopVoice播放顶部录音')
      if (this.isExamMode && status) return
      this.newQuestionList.forEach((question) => {
        question.playStatus = 'play'
      })
      this.topPlayStatus = 'pause'
      let audioPath = this.baseUrl + this.currItem.top_listen.audio_file
      console.log('题干播放链接===', audioPath)
      this.$player.play(audioPath, '', {}, isTryAgain)
      const _this = this
      this.$player.onended = (e) => {
        this.topPlayStatus = 'play'
        if (e == 'failed') {
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('common_video_failed'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              _this.clickPlayTopVoice(false, true)
              layer.close(index)
            },
            btn2: (index) => {
              _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
              layer.close(index)
            },
          })
        } else {
          console.log('onend触发，要emit handleRecordTypeListenEnd')
          _this.isExamMode && _this.$emit('handleRecordTypeListenEnd')
        }
      }
      this.$player.onloaded = (e) => {
        this.startTime = e
        this.middleTime = e
      }
      localStorage.setItem('bigIndex', this.currItem.bigIndex)
    },
    //重置播放状态
    resetPlayStatus(question, status) {
      let questions = this.newQuestionList.map((item) => {
        if (item.index === question.index) {
          item.playStatus = status
          console.log(item.playStatus)
          return item
        } else {
          item.playStatus = 'play'
          return {
            ...item,
          }
        }
      })
      this.newQuestionList = questions
      console.log(questions)
    },
    clickPauseTopVoice() {
      this.topPlayStatus = 'play'
      this.$player.pause()
    },
    autoPlay(obj, status) {
      this.middleTime = 0
      this.clickPlayTopVoice()
    },
  },
  // beforeDestroy() {
  //   // 停止播放
  //   this.$player.stop()
  //   // 录音停止；
  //   if (this.ifGroup) {
  //     let ref = eval('this.$refs.commonRef' + this.currItem.index)[0]
  //     ref && ref.noneSaveStop()
  //   } else {
  //     this.$nextTick(() => {
  //       this.$refs.commonRecorder.noneSaveStop()
  //     })
  //   }
  // },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 0px 29px 20px 29px;
  position: relative;
  .language-select-con {
    position: absolute;
    top: -60px;
    right: 100px;
    .title {
      color: #b5b5be;
      font-size: 12px;
      margin-bottom: -2px;
      position: relative;
      z-index: 100;
    }
    .language-select {
      width: 170px;
    }
  }
  .score-content {
    position: absolute;
    right: 23px;
    top: 16px;
  }
  .stem-content {
    img {
      cursor: pointer;
    }
  }
  .panel-content-text {
    padding-top: 50px;
  }
  .question_require {
    position: absolute;
    left: 0px;
    top: 45px;
    font-size: 12px;
    font-weight: 400;
    color: #3f4651;
    margin-top: 0px;
  }
  &-text {
    padding-top: 50px;

    .text-con {
      width: 100%;
      display: flex;
      position: relative;
      margin: 20px auto;
    }

    img {
      width: 100%;
      text-align: center;
      margin: auto;
      border-radius: 4px;
      object-fit: contain;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      color: #696974;
    }
  }

  .translation-question-stem {
    margin-top: 16px;
    color: #696974;
    font-size: 14px;
    line-height: 20px;
  }
  &-input {
    margin: 20px 0px 40px 0px;
    position: relative;
    .limit {
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 12px;
      font-weight: 400;
      color: #696974;
      margin-right: 7px;
      span {
        color: #b5b5be;
        margin-right: 4px;
      }
    }
    .input-box {
      padding: 5px 15px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      font-size: 14px;
      min-height: 100px;
      line-height: 21px;
    }
  }
  .analyse-con {
    margin-top: -30px;
  }
  &-result {
    width: 100%;
    // border-top: 1px dashed #e6eaef;
    padding: 30px 0px;
    .correct-answer {
      font-size: 14px;
      color: #545961;
      margin-top: 20px;
    }
    .orange {
      font-size: 14px;
      font-weight: 500;
      color: #fc5a5a;
    }
  }

  .correct-box {
    background: rgba(251, 252, 255, 1);
    border: 1px solid rgba(242, 243, 247, 1);
    border-radius: 10px;
    padding: 20px;

    &-title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(63, 70, 81, 1);
      margin-bottom: 10px;
    }
    &-answer {
      font-size: 14px;
      font-weight: 400;
      color: rgba(84, 89, 97, 1);
      line-height: 21px;
      white-space: pre-line;
    }
  }
}
.part-count-down-con {
  position: absolute;
  top: 16px;
  right: 15px;
}
::v-deep .language-select-con .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #b5b5be !important;
  color: #2c2f46;
  padding: 0 15px 0 0;
  border-radius: 0;
}
::v-deep .language-select-con .el-select .el-input .el-select__caret {
  font-weight: bold;
}
.example {
  background: #3f4651;
  border-radius: 4px;
  color: #fff;
  width: 25px;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  text-align: center;
  margin-right: 12px;
}
.panel-content-main {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.before-record-con {
  .microphone-img {
    width: 70px;
    height: 70px;
    cursor: not-allowed;
  }
}
.panel-content-details {
  // padding-top: 0;
}
.panel-content-play-con {
  display: flex;
  padding-top: 50px;
  align-items: center;
  justify-content: center;
}
.question-item {
  position: relative;
  border-top: 1px dashed #e7e7ed;
  padding: 30px 0;
}
.question-item:first-of-type {
  border: none;
}
.question-item-stem {
  //display: flex;
  align-items: center;
}
</style>
